import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressSpinnerModule, MatRadioModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { FcChoiceDialogComponent } from './fc-choice-dialog.component';
import { FcChoiceDialogService } from './fc-choice-dialog.service';

@NgModule({
  entryComponents: [
    FcChoiceDialogComponent
  ],
  declarations: [
    FcChoiceDialogComponent
  ],
  providers: [FcChoiceDialogService],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatRadioModule,
    MatInputModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    TranslateModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  exports: [
    FcChoiceDialogComponent
  ]
})
export class FcChoiceDialogModule { }
